import { BusinessDetails } from '../../constants/schema';

const searchList = (data: BusinessDetails[], q: any) => {
  const list: BusinessDetails[] = [];
  data.forEach((item) => {
    const identifier = item.identifier ? item.identifier.toLowerCase() : '';
    const entityName = item.entityName ? item.entityName.toLowerCase() : '';
    const children = searchList(item.__children, q) || [];
    if (
      entityName.indexOf(q) > -1 ||
      identifier.indexOf(q) > -1 ||
      children.length
    ) {
      list.push({ ...item, __children: children });
    }
  });
  return list;
};

export const searchQuery = (data: any, q: any) => {
  const query = q.trim().toLowerCase();
  if (!query) {
    return data;
  }
  return searchList(data, query);
};
